import * as Yup from 'yup';
import moment from 'moment';
import { DATE_FORMAT } from '../../../../../../forms/fields/FormField.component';
import { TemplateType } from '../../../../../../API';
import { FormConfigV2 } from '../../../../../../configs/form-configs/form-config-types';

export const initial_hearing_misconduct_executeOutcomeDismissalWithNotice: FormConfigV2 = {
  templateType: TemplateType.DISMISSAL_WITH_NOTICE_LETTER,
  fields: {
    incidents: 'array',
    initial_hearing_hearingDate: 'string',
    dismissalDate: 'string',
    lastRemunerationDate: 'string',
    lastWorkingDay: 'string',
    contactPersonInCaseOfCCMA: 'string',
    physicalAddress: 'string',
    emailAddress: 'string',
  },
  caseHistoryFields: {
    incidents: {
      type: 'table',
      label: 'Incidents',
      tableColumns: ['transgression'],
    },
    initial_hearing_hearingDate: {
      type: 'string',
      label: 'Date of Hearing',
    },
    dismissalDate: {
      type: 'string',
      label: 'Dismissal Date',
    },
    lastWorkingDay: {
      type: 'string',
      label: 'Last working day',
    },
    lastRemunerationDate: {
      type: 'string',
      label: 'Last remuneration date',
    },
    contactPersonInCaseOfCCMA: {
      type: 'string',
      label: 'Contact Person in Case of CCMA',
    },
    physicalExitDate: {
      type: 'string',
      label: 'Physical Exit Date',
    },
    physicalAddress: {
      type: 'string',
      label: 'Physical Address',
    },
    emailAddress: {
      type: 'string',
      label: 'Email Address',
    },
  },
  validationSchema: Yup.object().shape({
    incidents: Yup.array()
      .nullable()
      .required('Required'),
    initial_hearing_hearingDate: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    dismissalDate: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    lastRemunerationDate: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    lastWorkingDay: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    contactPersonInCaseOfCCMA: Yup.string().required('Required'),
    physicalAddress: Yup.string().required('Required'),
    emailAddress: Yup.string()
      .email('Email is not valid')
      .required('Required'),
  }),
};

export const initial_hearing_pp_executeOutcomeDismissalWithNotice = {
  templateType: TemplateType.DISMISSAL_WITH_NOTICE_PAY_LETTER_POOR_PERFORMANCE,
  fields: {
    performanceShortfalls: 'array',
    initial_hearing_hearingDate: 'string',
    dismissalDate: 'string',
    lastRemunerationDate: 'string',
    lastWorkingDay: 'string',
    contactPersonInCaseOfCCMA: 'string',
    physicalAddress: 'string',
    emailAddress: 'string',
  },
  caseHistoryFields: {
    performanceShortfalls: {
      type: 'table',
      label: 'Performance Shortfalls',
      tableColumns: ['shortfallDescription'],
    },
    initial_hearing_hearingDate: {
      type: 'string',
      label: 'Date of Hearing',
    },
    dismissalDate: {
      type: 'string',
      label: 'Dismissal Date',
    },
    lastWorkingDay: {
      type: 'string',
      label: 'Last working day',
    },
    lastRemunerationDate: {
      type: 'string',
      label: 'Last remuneration date',
    },
    contactPersonInCaseOfCCMA: {
      type: 'string',
      label: 'Contact Person in Case of CCMA',
    },
    physicalAddress: {
      type: 'string',
      label: 'Physical Address',
    },
    emailAddress: {
      type: 'string',
      label: 'Email Address',
    },
  },
  validationSchema: Yup.object().shape({
    performanceShortfalls: Yup.array()
      .nullable()
      .required('Required'),
    initial_hearing_hearingDate: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    dismissalDate: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    lastRemunerationDate: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    lastWorkingDay: Yup.string()
      .test('date', 'Date is not valid', val => moment(val, DATE_FORMAT).isValid())
      .required('Required'),
    contactPersonInCaseOfCCMA: Yup.string().required('Required'),
    physicalAddress: Yup.string().required('Required'),
    emailAddress: Yup.string()
      .email('Email is not valid')
      .required('Required'),
  }),
};
